import React, { Component } from "react";

class ContactForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        firstname: "",
        email: "",
        phone: "",
        dealer: "",
        message: "",
        checkbox1: false,
        checkbox2: false,
      },
      dealers: {
        "Porsche Tallinna esindus": "tallinn",
        "Porsche Now Tartu": "tartu",
      },
      isSubmitting: false,
      showModal: false,
      modalMessage: "",
      modalType: "", // 'success' or 'error'
    };
  }

  handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [name]: type === "checkbox" ? checked : value,
        komnr: this.props.komnr,
      },
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    try {
      const response = await fetch(
        //"http://porsche26.localhost/back/submit_form.php",
        //"https://rblr.eu/porsche/back/submit_form.php",
        "https://porsche.ee/kampaania/back/submit_form.php",

        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(this.state.formData),
        }
      );

      const result = await response.json();

      if (result.success) {
        this.showModal("Saadetud!", "success");
        // Reset form
        this.setState({
          formData: {
            firstname: "",
            email: "",
            phone: "",
            dealer: "",
            message: "",
            checkbox1: false,
            checkbox2: false,
          },
        });
      } else {
        this.showModal(result.message || "Error sending message.", "error");
      }
    } catch (error) {
      this.showModal("Ei õnnestunud. Palun proovi uuesti.", "error");
    } finally {
      this.setState({ isSubmitting: false });
    }
  };

  showModal = (message, type) => {
    this.setState({
      showModal: true,
      modalMessage: message,
      modalType: type,
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      modalMessage: "",
      modalType: "",
    });
  };

  render() {
    const {
      formData,
      dealers,
      isSubmitting,
      showModal,
      modalMessage,
      modalType,
    } = this.state;
    return (
      <div className="contact-form">
        <h2>Olen autost huvitatud</h2>
        <p>{this.props.data.kirjeldus}</p>
        <form onSubmit={this.handleSubmit}>
          {/* First Name */}
          <div className="form-group">
            <label htmlFor="firstname">Nimi</label>
            <input
              type="text"
              id="firstname"
              name="firstname"
              value={formData.firstname}
              onChange={this.handleInputChange}
              required
            />
          </div>

          {/* Email */}
          <div className="form-group">
            <label htmlFor="email">E-mail</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={this.handleInputChange}
              required
            />
          </div>

          {/* Phone */}
          <div className="form-group">
            <label htmlFor="phone">Telefon</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={this.handleInputChange}
              required
            />
          </div>

          {/* Dealer Selection */}
          <div className="form-group">
            <label htmlFor="dealer">Esindus</label>
            <select
              id="dealer"
              name="dealer"
              value={formData.dealer}
              onChange={this.handleInputChange}
              required
            >
              <option value="">Vali esindus</option>
              {Object.keys(dealers).map((dealer, index) => (
                <option key={index} value={dealers[dealer]}>
                  {dealer}
                </option>
              ))}
            </select>
          </div>

          {/* Checkbox 1 */}
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="checkbox1"
                checked={formData.checkbox1}
                onChange={this.handleInputChange}
      
              />
              Soovin liisingu- ja kaskokindlustuse pakkumist
            </label>
          </div>

          {/* Message */}
          <div className="form-group">
            <label htmlFor="message">Lisainfo</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={this.handleInputChange}
              rows="4"
            />
          </div>
          <p>
            Vormi saatmisega nõustud, et Sinuga võetakse selle päringuga seoses
            märgitud kanalite kaudu ühendust. Me töötleme Sinu isikuandmeid
            kooskõlas{" "}
            <a
              href="https://uudised.porsche.ee/et/legal/policy/1"
              target="_blank"
              rel="noreferrer"
            >
              Privaatsustingimused
            </a>{" "}
            ja{" "}
            <a
              href="https://uudised.porsche.ee/et/legal/policy/2"
              target="_blank"
              rel="noreferrer"
            >
              Küpsised
            </a>{" "}
            kirjeldatuga.'
          </p>
          {/* Checkbox 2 */}
          <div className="form-group checkbox-group">
            <label>
              <input
                type="checkbox"
                name="checkbox2"
                checked={formData.checkbox2}
                onChange={this.handleInputChange}
                required
              />
              <p>
                Soovin saada lisateavet teie toodete ja teenuste kohta ja annan
                nõusoleku seonduvaks andmetöötluseks vastavalt{" "}
                <a
                  href="https://uudised.porsche.ee/et/legal/policy/1"
                  target="_blank"
                  rel="noreferrer"
                >
                  Privaatsustingimused
                </a>{" "}
                ja{" "}
                <a
                  href="https://uudised.porsche.ee/et/legal/policy/2"
                  target="_blank"
                  rel="noreferrer"
                >
                  Küpsised
                </a>{" "}
                kirjeldatule.
              </p>
            </label>
          </div>

          {/* Google reCAPTCHA - You'll need to add your site key
          <div className="form-group">
            <div
              className="g-recaptcha"
              data-sitekey="YOUR_SITE_KEY"
              data-size="invisible"
              id="recaptcha"
            ></div>
          </div> */}

          {/* Submit Button */}
          <div className="form-group">
            <button type="submit" disabled={isSubmitting} className="button">
              {isSubmitting ? "Saadab..." : "SAADA PÄRING"}
            </button>
          </div>
        </form>

        {/* Modal */}
        {showModal && (
          <div className="modal-overlay">
            <div className={`modal ${modalType}`}>
              <div className="modal-content">
                <h3>
                  {modalType === "success"
                    ? "Saatmine õnnestus!"
                    : "Viga saatmisel!"}
                </h3>
                <p>{modalMessage}</p>
                <button onClick={this.closeModal}>Sulge</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default ContactForm;
